function isLoggedIn() {
	return sessionStorage.user && sessionStorage.token;
}

export default isLoggedIn;
